import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { actions } from './wrapperReducer';
import WrapperComponent from './WrapperComponent';

const WrapperContainer = ({ children, loading, fetchInitialData }) => {
  useEffect(() => {
    fetchInitialData();
  }, [fetchInitialData]);

  return <WrapperComponent loading={loading}>{children}</WrapperComponent>;
};

const mapStateToProps = (state) => ({
  loading: state.guardian.wrapper.loading,
});

const mapDispatchToProps = {
  fetchInitialData: actions.fetchInitialData,
};

export default connect(mapStateToProps, mapDispatchToProps)(WrapperContainer);
